import http from './http';

const pending = new Map();
function getInstructions(range) {
  if (pending.has(range)) return pending.get(range);
  const request = http
    .get(
      'https://sheets.googleapis.com/v4/spreadsheets/1fwpB90QUMyIZmvDyDPlS9ugTyP2H8Fpt3fayq3J88hs/values:batchGet',
      {
        timeout: 30000,
        params: {
          dateTimeRenderOption: 'FORMATTED_STRING',
          majorDimension: 'ROWS',
          ranges: range,
          key: 'AIzaSyAcQuG_DTI6mIpkGCKPoldQPac6sllaIdY',
        },
      }
    )
    .then((response) => {
      if (!Array.isArray(response.data?.valueRanges)) throw new Error('Invalid instructions response');
      for (const valueRange of response.data.valueRanges) valueRange.values ??= [];
      return response;
    })
    .finally(() => pending.delete(range));
  pending.set(range, request);
  return request;
}

export default {
  getHelpData() {
    return getInstructions('instructions!A:AQ');
  },
  getHelpAppData() {
    return getInstructions('App Instructions!A:AQ');
  },
  getHelpWhatsAppData() {
    return getInstructions('WhatsApp Instructions!A:AQ');
  },
  getSquirrelData() {
    return getInstructions('squirrel_instructions!A:AQ');
  },
  getTextingData() {
    return getInstructions('set1!A:AK');
  },
  getBQWVSData() {
    return getInstructions('Deer Cull and BQWVS!A:AB');
  },
  getLostDeerData() {
    return getInstructions('lost_deer_procedure!A:AB');
  },
  getDiseasesData() {
    return getInstructions('notifiable_diseases_procedure!A:AB');
  },
  getStructureData() {
    return getInstructions('structures_reporting!A:AB');
  },
  getInspectionData() {
    return getInstructions('skills_test!A:AB');
  },
  getWSData() {
    return getInstructions('WS1_WS3_reporting!A:AB');
  },
  generateSiteData(siteName) {
    return http.get(
      `https://wildtrack-frontend.nw.r.appspot.com/landcover?siteRef=${encodeURIComponent(siteName)}`
    );
  },
  generateAllSiteData(sites) {
    const allSites = sites.join(',');
    return http.get(
      `https://wildtrack-frontend.nw.r.appspot.com/landcoverAll?siteRef=${encodeURIComponent(allSites)}`
    );
  },
  generateSiteDataOverlay(siteName) {
    return http.get(
      `https://wildtrack-frontend.nw.r.appspot.com/landcover_overlay?siteRef=${encodeURIComponent(siteName)}`
    );
  },
};
